import { render, staticRenderFns } from "./ReaderResultPage.vue?vue&type=template&id=be97e474&scoped=true"
import script from "./ReaderResultPage.vue?vue&type=script&lang=js"
export * from "./ReaderResultPage.vue?vue&type=script&lang=js"
import style0 from "./ReaderResultPage.vue?vue&type=style&index=0&id=be97e474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be97e474",
  null
  
)

export default component.exports